import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export const dateFormatter = date => {
    if (date) {
        const timeZone = 'America/Sao_Paulo';
        const zonedFirstPublishedAt = utcToZonedTime(date, timeZone);
        const formatedDate = format(zonedFirstPublishedAt, "dd.MM.yyyy - HH'h'mm");

        return formatedDate;
    }

    return format(new Date(), "dd.MM.yyyy - HH'h'mm");
};
